import ScanDashboard from '../../components/ScanDashboard'

const ScanDashboardPage = () => {
  return <ScanDashboard />
}

export default ScanDashboardPage
